export default __webpack_public_path__ + "static/media/transportManagement.8dc0c778.svg";